var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTransactionVisaCashback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8234 11C25.1356 8.6997 22.7101 7 19.8234 7C16.9367 7 14.5111 8.6997 13.8234 11H25.8234Z",
    fill: "#0E5CF4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.82336,
    y: 11,
    width: 26,
    height: 18,
    rx: 1.2,
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8234 17H25.8234C24.1665 17 22.8234 18.3431 22.8234 20V20C22.8234 21.6569 24.1665 23 25.8234 23H32.8234",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8234 1C18.8234 2.33333 18.8234 5 18.8234 5",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8234 11C25.8234 13 25.8234 17 25.8234 17",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8234 23C25.8234 25 25.8234 29 25.8234 29",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8234 3C20.8234 3.66667 20.8234 5 20.8234 5",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8234 20C26.49 20 25.8234 20 25.8234 20",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTransactionVisaCashback);
export default __webpack_public_path__ + "static/media/ic-transaction-visa-cashback.dea2c434aa01bf98a749a91829e7c74a.svg";
export { ForwardRef as ReactComponent };